// Sent to backend auth calls and analytics as the attribution value for the Discover experience.
export const DISCOVER_REFERRER = 'booking';

// Discover's magic-link sign-up completes on a fresh page load (the user navigates away to
// click the emailed link), so the in-modal `onAuthSuccess` callback that normally fires
// `signup_completed` never runs. Stashing the mode onto the magic link's redirect URL lets
// `useAuthenticate` recover it and fire the event once the token is exchanged.
export const DISCOVER_AUTH_MODE_PARAM = 'discoverAuthMode';
